'use strict';

const propTypes = require('prop-types');
const React = require( 'react' );
const { object, string } = propTypes;
const DateHelper = require( '../../../../../_plugins/lib/dateHelper.js' );
const Helpers = require( '../../../../../_plugins/lib/helpers' );

const getAirportInfo = require( '../getAirportInfo.js' );
const Modal = require( '../modal.jsx' );
const createReactClass = require('create-react-class');

const GetCachedPrice = createReactClass({
  mixins: [Helpers],

  propTypes: {
    id: string.isRequired,
    pageData: object
  },

  //Tech debt #181
  getProduct( ) {
    const { pageData: { productClass } } = this.props;
    switch ( productClass.toUpperCase( ) ) {
    case 'CP':
      return {
        path: 'parking/',
        tablePath: 'parkingLocations/',
        type: 'CP'
      };
    case 'HCP':
      return {
        path: 'hotels/',
        tablePath: 'hotelLocations/',
        type: 'HCP'
      };
    case 'HO':
      return {
        path: 'hotels/',
        tablePath: 'hotelLocations/',
        type: 'HO'
      };
    }
    return false;
  },

  getPriceInformation( product, location ) {
    try {
      const { prices } = require( '../../../../../config/exports/prices/' + product.path + location + '.json' );
      return prices;
    } catch (e) {
      return false;
    }
  },

  getCheapestProductName( product, location ) {
    try {
      const prices = require( '../../../../../config/exports/' + product.tablePath + location + '.json' );
      return prices[Object.keys( prices )[0]].prodlib.name;
    } catch (e) {
      return false;
    }
  },

  convertIsoToEnglish( dateString ) {
    if ( !dateString ) return '';
    const split = dateString.split( '-' );
    return split[2] + '/' + split[1] + '/' + split[0];
  },

  getContentForModal( location, priceInformation, cheapestProductName, productType ) {
    const info = {};
    let content;
    if ( productType === 'CP' ) {
      info.dateSearchWasMade = priceInformation.dateUsed.replace( /\-/g, '/' );
      info.startDate = priceInformation.startDate.replace( /\-/g, '/' );
      info.endDate = priceInformation.endDate.replace( /\-/g, '/' );
    } else {
      info.dateSearchWasMade = this.convertIsoToEnglish( priceInformation.lowestPriceDateSearchWasMade );
      info.startDate = this.convertIsoToEnglish( priceInformation.lowestPriceDateSearchedFor );
      info.endDate = this.convertIsoToEnglish( DateHelper.alterDateByNumberOfDays( DateHelper.parseIsoDate( priceInformation.lowestPriceDateSearchedFor ), '+7' ).toISOString( ).split( 'T' )[0] );
    }

    const { dateSearchWasMade, startDate, endDate } = info;
    switch ( productType ) {
    case 'CP':
      content = (
        <div>
            <p>This is an example price which refers to our cheapest airport parking product available at { location.name } Airport within the next 61 days, when searched at 12am on { dateSearchWasMade }</p>
            <p>The quoted price today was for { cheapestProductName } parking from { startDate } to { endDate } and is the total cost for 8 days (the typical parking requirement for a 1 week trip).</p>
            <p>Please note: live prices are fluid and constantly changing according to availability and supplier pricing and, as such, may be different to the advertised price. It is intended as a guide price only, demonstrating the most accurate, cheapest price we anticipate being available today.</p>
        </div>
      );
      break;
    case 'HO':
    case 'HCP':
      content = (
        <div>
          <p>These prices refer to our cheapest hotel and our cheapest hotel with parking package available at { location.name } Airport within the next 61 days, at 12am on { dateSearchWasMade }.</p>
          <p>The quoted prices today are for the { cheapestProductName } on { startDate } to { endDate } at 12am searched for on { dateSearchWasMade }. Please note: live prices are fluid and constantly changing according to availability and supplier pricing and, as such, may be different to the advertised price. It is intended as a guide price only, demonstrating the most accurate, cheapest price we anticipate being available today.</p>
        </div>
      );
      break;
    }

    return content;
  },

  standardRender( ) {
    const { id, pageData: { pageName } } = this.props;
    const product = this.getProduct( );
    const location = getAirportInfo( pageName );
    const { code } = location;
    let priceInformation = ( product ) ? this.getPriceInformation( product, location.code ) : false;
    let cheapestProductName = ( product ) ? this.getCheapestProductName( product, location.code ) : false;
    if ( !priceInformation || priceInformation.hasOwnProperty('error') ) return null;
    return (
      <span id={ id }>
        <a style={ { cursor: 'pointer' } } data-toggle="modal" data-target={ '#' + code + 'PriceExplainedModal' }> (?)</a>
        <Modal id={ code + 'PriceExplainedModal' } heading={ 'From Prices Explained' } content={ this.getContentForModal( location, priceInformation, cheapestProductName, product.type ) } />
      </span>
    );
  },

  getModalHtml( ) {
    const { id } = this.props;
    try {
      const existingHTML = this.$( '#' + id, document );
      return ( <span id={ id } dangerouslySetInnerHTML={{ __html: existingHTML.innerHTML }} /> );
    } catch ( e ) {
      return this.standardRender( );
    }
  },

  render( ) {
    const modalData = this.getModalHtml( );
    return modalData;
  }

});

module.exports = GetCachedPrice;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/modals/PricesExplainedModal.jsx